<template>
  <section class="dashboard section is-full-touch is-full mobile">
    <div class="container is-fluid-desktop is-full-touch is-full-mobile">
      <div class="is-hidden-desktop is-hidden-widescreen">
        <Mobilemenu />
      </div>
      <div class="columns">
        <div
            class="column is-narrow-desktop is-hidden-mobile is-hidden-touch sbar"
        >
          <Sidebar />
        </div>
        <div class="column">
          <div class="block">
            <h1 class="title block">Payments</h1>
            <h2 class="subtitle block">
              Enable or disable payment methods. Bitcoin deposits are enabled by default until explicitly disabled.
            </h2>
          </div>
          <div class="block">
            <button
                @click="toggleBtcPayments()"
                class="button"
                :class="btcPaymentsEnabled ? 'is-primary' : 'is-danger'"
            >{{ btcPaymentsStatus }} BTC payments</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import {db} from "@/firebase";
import Mobilemenu from "@/components/Mobilemenu";

export default {
  name: "SettingsPaymentsView",
  components: {
    Sidebar,
    Mobilemenu
  },
  data() {
    return {
      payments: null,
    }
  },
  firestore: {
    payments: db.collection('settings').doc('payments')
  },
  computed: {
    btcPaymentsEnabled() {
      return this.payments?.btcEnabled !== false
    },
    btcPaymentsStatus() {
      return this.btcPaymentsEnabled ? 'Disable' : 'Enable'
    }
  },
  methods: {
    async toggleBtcPayments() {
      try {
        const newValue = !this.btcPaymentsEnabled
        if (this.payments === null) {
          await db.collection('settings').doc('payments').set({
            btcEnabled: newValue
          })
        } else {
          await this.$firestoreRefs.payments.update({
            btcEnabled: newValue
          })
        }
        alert('Updated');
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
